<div class="requirements-compliance-score">
  <div class="requirements-compliance-score__chart">
    <highcharts-chart
      class="highcharts-light"
      [options]="chartOptions()"
    />
    <ng-template #empty> No data available </ng-template>
  </div>
</div>
